import { render, staticRenderFns } from "./FormPaymentButtons.vue?vue&type=template&id=ed4e50ea"
import script from "./FormPaymentButtons.vue?vue&type=script&lang=js"
export * from "./FormPaymentButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports